<template>
    <component
        :is="tag"
        v-bind="$attrs"
        class="z-button"
        :class="classObject"
        :href="tag === 'a' ? href : false"
    >
        <div v-if="hasLeftSlot" class="z-button__icon z-button__icon--align-left">
            <slot name="left" />
        </div>
        <span class="z-button__text-wrapper"><span><slot /></span></span>
        <div v-if="hasRightSlot" class="z-button__icon z-button__icon--align-right">
            <slot name="right" />
        </div>
    </component>
</template>

<script setup>
import {computed, useSlots} from 'vue';

const props = defineProps({
    tag: {
        type: String,
        default: 'button',
        comment: 'Used if the button is a link or the standard button is not suitable for some reason'
    },
    kind: {
        type: String,
        validator: prop => [
            'primary',
            'secondary',
            'bordered'
        ].includes(prop),
        default: 'primary'
    },
    onlyIcon: {
        type: Boolean,
        default: false,
    },
    loading: {
        type: Boolean,
        default: false,
    },
    href: {
        type: String,
    },
    size: {
        type: String,
        validator: prop => ['s', 'm', 'l'].includes(prop),
        default: 'm'
    }
})

const slots = useSlots()

const hasLeftSlot = computed(() => {
    return !!slots['left']
})

const hasRightSlot = computed(() => {
    return !!slots['right']
})

const classObject = computed(() => {
    return [
        {'z-button--only-icon': props.onlyIcon},
        `z-button--kind-${props.kind}`,
        `z-button--size-${props.size}`,
        {'z-button--loading': props.loading}
    ]
})

defineExpose({
    props
})
</script>

<style lang="scss" src="./index.scss"></style>
